<template>
	<div class="biochemical">
		<h3 class="qjc-fts-16 qjc-ftw-500 qjc-c-dark">填写各项生化指标</h3>
	
		<el-form
			class="qjc-clearfix"
		>
			<el-form-item
				label="白细胞(WBC)："
				class="qjc-fl qjc-wid-50"
			>
				<el-input
					v-model="formData.examine[0].ve"
					@input="mustNumber(0)"
					placeholder="请输入"
					@blur="inputRange(0, 0, 150)"
				>
					<div class="suffix qjc-fts-14" slot="suffix">
						10³/μl
					</div>
				</el-input>
			</el-form-item>
			
			<el-form-item
				label="血红蛋白(HGB)："
				class="qjc-fl qjc-wid-50"
			>
				<el-input
					v-model="formData.examine[1].ve"
					@input="mustNumber(1)"
					placeholder="请输入"
					@blur="inputRange(1, 1, 25)"
				>
					<div class="suffix qjc-fts-14" slot="suffix">
						g/dL
					</div>
				</el-input>
			</el-form-item>
			
			<el-form-item
				label="血小板(PLT)："
				class="qjc-fl qjc-wid-50"
			>
				<el-input
					v-model="formData.examine[2].ve"
					@input="mustNumber(2)"
					placeholder="请输入"
					@blur="inputRange(2, 1, 1800)"
				>
					<div class="suffix qjc-fts-14" slot="suffix">
						10³/μl
					</div>
				</el-input>
			</el-form-item>
			
			<el-form-item
				label="空腹血糖(FG)："
				class="qjc-fl qjc-wid-50"
			>
				<el-input
					v-model="formData.examine[3].ve"
					@input="mustNumber(3)"
					placeholder="请输入"
					@blur="inputRange(3, 30, 700, 1.5, 40)"
				>
					<div class="suffix qjc-fts-14" slot="suffix">
						<el-radio-group
							v-model="formData.examine[3].ut"
						>
							<el-radio label="A">mg/dL</el-radio>
							<el-radio label="B">mmol/mol</el-radio>
						</el-radio-group>
					</div>
				</el-input>
			</el-form-item>
			
			<el-form-item
				label="糖化血红蛋白(HBA1C)："
				class="qjc-fl qjc-wid-50"
			>
				<el-input
					v-model="formData.examine[4].ve"
					@input="mustNumber(4)"
					placeholder="请输入"
					@blur="inputRange(4, 1, 25)"
				>
					<div class="suffix qjc-fts-14" slot="suffix">
						%
					</div>
				</el-input>
			</el-form-item>
			
			<el-form-item
				label="总胆固醇(CHOL)："
				class="qjc-fl qjc-wid-50"
			>
				<el-input
					v-model="formData.examine[5].ve"
					@input="mustNumber(5)"
					placeholder="请输入"
					@blur="inputRange(5, 50, 1100, 1.2, 28.5)"
				>
					<div class="suffix qjc-fts-14" slot="suffix">
						<el-radio-group
							v-model="formData.examine[5].ut"
						>
							<el-radio label="A">mg/dL</el-radio>
							<el-radio label="B">mmol/L</el-radio>
						</el-radio-group>
					</div>
				</el-input>
			</el-form-item>
			
			<el-form-item
				label="低密度脂蛋白(LDLC)："
				class="qjc-fl qjc-wid-50"
			>
				<el-input
					v-model="formData.examine[6].ve"
					@input="mustNumber(6)"
					placeholder="请输入"
					@blur="inputRange(6, 1, 650, 0, 17)"
				>
					<div class="suffix qjc-fts-14" slot="suffix">
						<el-radio-group
							v-model="formData.examine[6].ut"
						>
							<el-radio label="A">mg/dL</el-radio>
							<el-radio label="B">mmol/L</el-radio>
						</el-radio-group>
					</div>
				</el-input>
			</el-form-item>
			
			<el-form-item
				label="高密度脂蛋白(HDLC)："
				class="qjc-fl qjc-wid-50"
			>
				<el-input
					v-model="formData.examine[7].ve"
					@input="mustNumber(7)"
					placeholder="请输入"
					@blur="inputRange(7, 1, 250, 0, 7)"
				>
					<div class="suffix qjc-fts-14" slot="suffix">
						<el-radio-group
							v-model="formData.examine[7].ut"
						>
							<el-radio label="A">mg/dL</el-radio>
							<el-radio label="B">mmol/L</el-radio>
						</el-radio-group>
					</div>
				</el-input>
			</el-form-item>
			
			<el-form-item
				label="甘油三酯(TG)："
				class="qjc-fl qjc-wid-50"
			>
				<el-input
					v-model="formData.examine[8].ve"
					@input="mustNumber(8)"
					placeholder="请输入"
					@blur="inputRange(8, 1, 9000, 0, 110)"
				>
					<div class="suffix qjc-fts-14" slot="suffix">
						<el-radio-group
							v-model="formData.examine[8].ut"
						>
							<el-radio label="A">mg/dL</el-radio>
							<el-radio label="B">mmol/L</el-radio>
						</el-radio-group>
					</div>
				</el-input>
			</el-form-item>
			
			<el-form-item
				label="谷草转氨酶GOT："
				class="qjc-fl qjc-wid-50"
			>
				<el-input
					v-model="formData.examine[9].ve"
					@input="mustNumber(9)"
					placeholder="请输入"
					@blur="inputRange(9, 1, 2000)"
				>
					<div class="suffix qjc-fts-14" slot="suffix">
						IU/L(U/L)
					</div>
				</el-input>
			</el-form-item>
			
			<el-form-item
				label="谷丙转氨酶GPT："
				class="qjc-fl qjc-wid-50"
			>
				<el-input
					v-model="formData.examine[10].ve"
					@input="mustNumber(10)"
					placeholder="请输入"
					@blur="inputRange(10, 1, 4000)"
				>
					<div class="suffix qjc-fts-14" slot="suffix">
						IU/L(U/L)
					</div>
				</el-input>
			</el-form-item>
			
			<el-form-item
				label="碱性磷酸酶(ALP)："
				class="qjc-fl qjc-wid-50"
			>
				<el-input
					v-model="formData.examine[11].ve"
					@input="mustNumber(11)"
					placeholder="请输入"
					@blur="inputRange(11, 1, 6500)"
				>
					<div class="suffix qjc-fts-14" slot="suffix">
						IU/L(U/L)
					</div>
				</el-input>
			</el-form-item>
			
			<el-form-item
				label="白蛋白(ALB)："
				class="qjc-fl qjc-wid-50"
			>
				<el-input
					v-model="formData.examine[12].ve"
					@input="mustNumber(12)"
					placeholder="请输入"
					@blur="inputRange(12, 1, 7, 10, 70)"
				>
					<div class="suffix qjc-fts-14" slot="suffix">
						<el-radio-group
							v-model="formData.examine[12].ut"
						>
							<el-radio label="A">g/dL</el-radio>
							<el-radio label="B">g/L</el-radio>
						</el-radio-group>
					</div>
				</el-input>
			</el-form-item>
			
			<el-form-item
				label="肌酐(CRE)："
				class="qjc-fl qjc-wid-50"
			>
				<el-input
					v-model="formData.examine[13].ve"
					@input="mustNumber(13)"
					placeholder="请输入"
					@blur="inputRange(13, 0, 40, 0, 3600)"
				>
					<div class="suffix qjc-fts-14" slot="suffix">
						<el-radio-group
							v-model="formData.examine[13].ut"
						>
							<el-radio label="A">mg/dL</el-radio>
							<el-radio label="B">μmol/L</el-radio>
						</el-radio-group>
					</div>
				</el-input>
			</el-form-item>
			
			<el-form-item
				label="尿酸(UA)："
				class="qjc-fl qjc-wid-50"
			>
				<el-input
					v-model="formData.examine[14].ve"
					@input="mustNumber(14)"
					placeholder="请输入"
					@blur="inputRange(14, 0, 20, 0, 1200)"
				>
					<div class="suffix qjc-fts-14" slot="suffix">
						<el-radio-group
							v-model="formData.examine[14].ut"
						>
							<el-radio label="A">mg/dL</el-radio>
							<el-radio label="B">μmol/L</el-radio>
						</el-radio-group>
					</div>
				</el-input>
			</el-form-item>
			
			<el-form-item
				label="肾小球滤过率(EGFR)："
				class="qjc-fl qjc-wid-50"
			>
				<el-input
					v-model="formData.examine[15].ve"
					@input="mustNumber(15)"
					placeholder="请输入"
					@blur="inputRange(15, 1, 300)"
				>
					<div class="suffix qjc-fts-14" slot="suffix">
						ml/min/1.73m<sup>2</sup>
					</div>
				</el-input>
			</el-form-item>
			
			<el-form-item class="qjc-fl qjc-wid-100 qjc-texta-c">
				<el-button @click="submit" :loading="submiting" class="submit qjc-fts-16 qjc-ftw-500">确认提交</el-button>
			</el-form-item>
			
		</el-form>
	</div>
</template>

<script>
	import { sbpHealth } from '@/utils/axios'
	
	export default{
		name: 'biochemical',
		data() {
			return {
				
				submiting: false
			}
		},
		props: ['type', 'formData'],
		methods: {
			// 确认提交
			submit() {
				// 添加操作人
				this.formData.operator = localStorage.getItem('mobile');
				
				
				if(!this.verifyNull()){
					
					this.submiting = true;
					
					sbpHealth(this.formData).then(res => {
						
						this.submiting = false;
						
						if(res.code == 200){
							this.$myAlert({
								title: this.type == 'insert'?'录入成功':'修改成功',
								type: 'success',
								callback: () => {
									location.reload();
								}
							});
						}else{
							this.$myAlert({
								type: 'fail',
								content: res.msg
							});
						}
					});
				}
		
			},
			//验证不为空
			verifyNull() {
				for(var i=0;i<this.formData.examine.length;i++){
					if(this.formData.examine[i].ve == '' && i != 15){// i=15(肾小球过滤率)暂时可为空
						this.$myAlert({
							title: '不能为空',
							content: '请输入：' + this.formData.examine[i].ne
						});
						return true;
					}
				}
				
				return false;
			},
			
			//必须输入数字 参数：对应examine下标
			mustNumber(index) {
				this.formData.examine[index].ve = this.formData.examine[index].ve.match(/\d/g)?this.formData.examine[index].ve.match(/[\d || .]/g).join(''):'';
			},
			
			//输入偏差提示 参数：1.data中examine下标  2.最小值(存在单位切换时为A单位最小值)  3.最大值(存在单位切换时为A单位最大值)  4.B最小值(存在单位切换时为B单位最小值) 5.B最大值(存在单位切换时为B单位最小值)
			inputRange(index, min, max, min2, max2){
				if(this.formData.examine[index].ve != ''){
					if(min2 || max2 && this.formData.examine[index].ut == 'B'){//存在单位切换且为单位为B值时
						if(this.formData.examine[index].ve < min2 || this.formData.examine[index].ve > max2){
							this.$myAlert({
								title: '确认输入信息',
								content: "您填写的结果可能存在较大偏差，请您仔细核对该数值和所用单位是否正确并与您的报告一致。<br/>若您已经核对确认，并坚持以该结果进行提交和评估，我们可能会根据AI算法对该结果进行一定程度上的修正和处理，以提供更合理的大数据评估结果和建议。"
							});
						}
						
					}else{
						if(this.formData.examine[index].ve < min || this.formData.examine[index].ve > max){
							this.$myAlert({
								title: '确认输入信息',
								content: "您填写的结果可能存在较大偏差，请您仔细核对该数值和所用单位是否正确并与您的报告一致。<br/>若您已经核对确认，并坚持以该结果进行提交和评估，我们可能会根据AI算法对该结果进行一定程度上的修正和处理，以提供更合理的大数据评估结果和建议。"
							});
						}
					}
				}
				
			}
		}
	}
</script>

<style scoped>
	.biochemical >>> .el-form-item__label{
		font-size: 0.14rem;
		line-height: 0.14rem;
		margin-bottom: 0.1rem;
		color: #777F8F;
	}
	.biochemical >>> .el-input{
		height: 0.32rem;
		line-height: 0.32rem;
	}
	.biochemical >>> .el-input input{
		height: 0.32rem;
		line-height: 0.14rem;
		font-size: 0.14rem;
		padding: 0.1rem 0.12rem;
	}
	.biochemical >>> .el-radio__label{
		font-size: 0.14rem;
	}
</style>
<style lang="scss" scoped>
	.biochemical{
		padding-top: 0.32rem;
		
		.el-form{
			margin-top: 0.22rem;
			
			.el-form-item{
				margin-bottom: 0.24rem;
				
				.el-input{
					width: 5.51rem;
					
					.el-radio{
						font-weight: normal;
						color: #777F8F;
					}
					.suffix{
						color: #777F8F;
						margin-right: 0.16rem;
						
						sub{
							display: inline-block;
							vertical-align: baseline;
							font-size: inherit;
							transform: translateY(9%)scale(.65);
						}
						sup{
							display: inline-block;
							vertical-align: top;
							font-size: inherit;
							transform: translateY(-9%)scale(.65);
						}
					}
				}
				
				.submit{
					width: 2rem;
					height: 0.48rem;
					margin-top: 0.4rem;
				}
			}
		}
		
	}
</style>
